// extracted by mini-css-extract-plugin
export default {"call-list":"app-phone_banks-PhoneBankForm-PhoneBankForm-module__RFFhjzb8dbX5WrzmmSYo"};